import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import { getUserInfo } from "@/api/common";
import { logOut } from "@/api/home";

Vue.use(Vuex);
const pinyin = require("js-pinyin");

export default new Vuex.Store({
  state: {
    // 0 未登录 1 普通 2 年框 后端返回普通用户0 年框1
    identity: JSON.parse(localStorage.getItem("userInfo"))
      ? JSON.parse(localStorage.getItem("userInfo")).level == 0
        ? 1
        : 2
      : 0,
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || "",
    loginDialogVisible: JSON.parse(localStorage.getItem("userInfo"))
      ? false
      : true,
    search: localStorage.getItem("search")
      ? localStorage.getItem("search")
      : "",
    loading: false,
    axiosCancelArr: [],
    feedbackVisible: true,
    showWindow: false,
    showShare: false,
    showSharePackage: false,
    shareData: {
      caseList: [],
      decorateList: [],
      customList: [],
    },
  },

  getters: {},

  mutations: {
    // 更新用户信息
    updateUserInfo(state, data) {
      state.userInfo = data;
      state.identity = data.level === 0 ? 1 : 2;
      window.qimoClientId = {
        userId: pinyin.getCamelChars(data.name), // 自定义用户的唯一id，不能传空字符串、null、中文，id由字母大小写、数字及'-'和 '_'组成
        priority: false, //是否优先进线设置，非必填，值为boolean类型的true或false
        nickName: data.name, //自定义用户昵称，定义用户昵称则userId必传
      };
      window.m7CardInfo = null;
      localStorage.setItem("userInfo", JSON.stringify(data));
      // 更新页面顶部ico标识
      updateHeadIcon(state);
    },

    //
    onShowShare(state, data) {
      state.showShare = data;
    },
    //
    onShowSharePackage(state, data) {
      state.showSharePackage = data;
    },
    onUpdateCaseList(state, data) {
      console.log(data, "data");
      state.shareData.caseList = data;
      console.log(this.state.shareData.caseList, "casc");
    },
    onUpdateDecorateList(state, data) {
      state.shareData.decorateList = data;
    },
    onUpdateCustomList(state, data) {
      state.shareData.customList = data;
    },

    // 退出登录
    signOut(state) {
      if (!localStorage.getItem("token")) {
        return;
      }
      logOut().then((res) => {
        window.localStorage.clear();
        router.push({ name: "/home" });
        router.go(0);
        state.loginDialogVisible = true;
        // store.commit('onShowLogindialog', true)
      });
    },

    // 在线咨询
    onlineConsult(state, data) {
      window.m7CardInfo = {};
      window.qimoChatClick();
    },

    closeOnlineConsult() {
      window.m7CardInfo = {};
      window.qimosdk.closeChatBox();
    },

    onShowLogindialog(state, data) {
      state.loginDialogVisible = data;
    },

    // 更新用户信息
    async onUpdateUserInfo(state, data) {
      try {
        const res = await getUserInfo();
        state.userInfo = res.data;
        state.identity = res.data.level === 0 ? 1 : 2;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        // 更新页面顶部ico标识
        updateHeadIcon(state);
      } catch (e) {
        console.log(e);
      }
    },
    onSearch(state, data) {
      state.search = data;
      localStorage.setItem("search", data);
    },
    onChangeShowWindow(state, data) {
      state.showWindow = data;
    },
    PUSH_CANCEL(state, cancel) {
      state.axiosCancelArr.push(cancel.cancelToken);
    },
    CLEAR_CANCEL(state) {
      state.axiosCancelArr.forEach((e) => {
        e && e();
      });
      state.axiosCancelArr = [];
    },
    // 网络加载
    CLOSE_LOADING(state) {
      state.loading = false;
    },
    OPEN_LOADING(state) {
      state.loading = true;
    },

    
  },
  actions: {
    pushCancel({ commit }, cancel) {
      commit("PUSH_CANCEL", cancel);
    },
    clearCancel({ commit }) {
      commit("CLEAR_CANCEL");
    },
  },
  modules: {},
});

/**
 * 工具方法 仅用于设置页面顶部ico标识更新  会员或非会员 
 * @param {Object} state - 状态对象
 * @returns {void}
 */
const updateHeadIcon = (state) => {
  const head = document.getElementsByTagName("head")[0];
  const href = state.identity !== 2 ? "ico-c.ico" : "ico-v.ico";
  let link = head.querySelector('link[rel="icon"], link[rel="shortcut icon"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "shortcut icon");
    link.setAttribute("href", href);
    head.appendChild(link);
  } else {
    link.setAttribute("href", href);
  }
};
